<div class="content-container" role="main" [attr.aria-busy]="!ticket ? 'true' : 'false'" aria-live="assertive">
  @if (theme.theme.mainTheme !== themeType.Custom) {
    <id-card>
      <ng-container *ngTemplateOutlet="frejaEidAuthenticationContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="frejaEidAuthenticationContent"></ng-container>
    </div>
  }

  <ng-template #frejaEidAuthenticationContent>
    <div class="flex flex-column flex-align-center">
      <img class="icon" src="assets/images/FRoundedIndigo.svg" alt="Freja eID ikon" />

      <h1 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }} ids-mt-5">
        {{ getTypeText() }}
      </h1>
      <h2 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mb-5">
        {{ clientInfo?.organizationName }}
      </h2>

      @if (!pending) {
        <h3 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }}">
          Starta appen
        </h3>
        @if (!ticket) {
          <div class="flex flex-center margin-50">
            <app-loading-spinner></app-loading-spinner>
          </div>
        } @else {
          <div class="panel-content flex flex-align-center flex-column">
            @if (isSameDevice) {
              <div class="instructions-text-container">
                @if (!isAndroid || (isAndroid && !isSingleMethod())) {
                  <p class="instructions-text">Applikationen Freja startas på din enhet.</p>
                } @else if (isAndroid && isSingleMethod()) {
                  <p class="instructions-text">
                    <strong> Tryck på knappen nedan för att starta Freja på denna enhet. </strong>
                  </p>
                }

                <p class="instructions-text">
                  Följ instruktionerna i appen för att slutföra {{ getMethodTypeText() }}.
                </p>
              </div>
            } @else {
              <div class="instructions-text-container">
                <p class="instructions-text">
                  Starta appen Freja på din mobil eller surfplatta för att skanna QR-koden.
                </p>
              </div>

              @if (displayQrCode) {
                <div class="qr-code ids-mt-3">
                  <img [src]="base64Prefix + qrTokenB64" alt="QR-kod" />
                </div>
              }
            }

            @if (!isStarting) {
              <div class="ids-mb-3">
                <id-link>
                  <a href="javascript:void(0);" (click)="manualAutostart()">Starta Freja på denna enhet</a>
                </id-link>
              </div>
            } @else {
              <div class="flex flex-center margin-50">
                <app-loading-spinner></app-loading-spinner>
              </div>
            }

            <id-link>
              <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
            </id-link>
          </div>
        }
      }

      @if (pending) {
        <div class="panel-content flex flex-align-center flex-column">
          <div class="instructions-text-container">
            <p class="instructions-text">
              Följ anvisningar i Freja applikationen för att slutföra {{ getMethodTypeText() }}.
            </p>
          </div>

          <div class="flex flex-center margin-50">
            <app-loading-spinner></app-loading-spinner>
          </div>

          <div class="ids-mt-3">
            <id-link>
              <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
            </id-link>
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>
